import { Observable } from "rxjs";

export abstract class IsWalletAvailableService {
    /**
     * Checks if the wallet should be available to the user
     */
    abstract execute(): Observable<boolean>;
}